
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "react-router-dom";

interface CategoryCardProps {
  id: string;
  name: string;
  slug: string; // Add slug field
  image: string;
  description?: string; // Keep but make optional
  subCategoryCount?: number; // Keep but make optional
  productCount?: number; // Keep but make optional
  featured?: boolean; // Keep but make optional
}

import { getCloudinaryUrl } from "@/lib/cloudinary";

export default function CategoryCard({
  name,
  slug,
  image,
  // description,
  // subCategoryCount,
  // productCount,
  // featured = false,
}: CategoryCardProps) {
  return (
    <Link to={`/${slug}`} className="block group">
      <Card className="overflow-hidden transition-all duration-300 hover:shadow-md border-none h-full bg-transparent hover:bg-white/50">
        <div className="flex flex-col h-full items-center text-center">
          <div className="relative w-24 h-24 mb-3 overflow-hidden">
            <img
              src={getCloudinaryUrl(image, 200, 200)}
              srcSet={`
                ${getCloudinaryUrl(image, 100, 100)} 100w,
                ${getCloudinaryUrl(image, 200, 200)} 200w,
                ${getCloudinaryUrl(image, 300, 300)} 300w
              `}
              sizes="(max-width: 600px) 100px, 200px"
              alt={name}
              className="w-full h-full object-contain transition-transform duration-300 group-hover:scale-110"
            />
          </div>
          
          <CardContent className="p-2 flex flex-col items-center">
            <h3 className="text-sm font-medium line-clamp-2 text-gray-800 group-hover:text-primary transition-colors duration-200">
              {name}
            </h3>
          </CardContent>
        </div>
      </Card>
    </Link>
  );
}
